import { ViewChild, ViewContainerRef, AfterViewInit, Component, EventEmitter, Input, OnInit, Output, Compiler, Injector, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-whack-a-bingo-preview',
    templateUrl: './whack-a-bingo-preview.component.html',
    styleUrls: ['./whack-a-bingo-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WhackABingoPreviewComponent implements OnInit, AfterViewInit {
  @ViewChild('featurePrevieContainer', { read: ViewContainerRef }) featurePrevieContainer: ViewContainerRef;
  @Input() gameAssets;
  @Input() txtColor;
  @Input() isDefaultPreview;
  @Input() selectedLabel;
  @Input() fontObj;
  @Input() wabType;
  @Input() mode;
  @Input() on_points_info;
  @Output() confirmAssets = new EventEmitter();
  @Output() playSounds = new EventEmitter();
  @Output() onSaveconfig = new EventEmitter();

  wabConfig = {
    "gameData": {
      "wabbitInd": 0,
      "displayName": "WABCHATTESTFOXY",
      "popupDelay": 2,
      "stayUpTime": 1,
      "hitPoints": 15,
      "playTime": 30,
      "remainingTime": 30,
      "isPointType": false,
      "reward": "0",
      "prize": 0,
      "score": 0,
      "state": "in_progress",
      "introTxt": "Welcome to Whack A Bingo Chat",
      "totalPrize": {
        "Bonus_GBP": 0,
        "Freespins_GBP": 0,
        "Freetickets_GBP": 0,
        "Cash_GBP": 0
      },
      "isWon": false,
      "wagered_amount": 0,
      "successHits": 0,
      "sentHits": 0,
      "missHits": 0,
      "popOutSequence": [
        {
          "pos": 9,
          "hit": ""
        },
        {
          "pos": 8,
          "hit": ""
        },
        {
          "pos": 3,
          "hit": ""
        },
        {
          "pos": 5,
          "hit": ""
        },
        {
          "pos": 11,
          "hit": ""
        },
        {
          "pos": 1,
          "hit": ""
        },
        {
          "pos": 9,
          "hit": ""
        },
        {
          "pos": 8,
          "hit": ""
        },
        {
          "pos": 3,
          "hit": ""
        },
        {
          "pos": 5,
          "hit": ""
        },
        {
          "pos": 9,
          "hit": ""
        },
        {
          "pos": 8,
          "hit": ""
        },
        {
          "pos": 3,
          "hit": ""
        },
        {
          "pos": 5,
          "hit": ""
        },
        {
          "pos": 8,
          "hit": ""
        },
      ],
      "gameType": "leader_board"
    }
  }
  bonusType = "Bingo bonus";



  constructor(private compiler: Compiler, private injector: Injector) {
  }


  ngOnInit(): void {
    console.log("seshagiri", this.wabType)
    let assets = {};
    for (let assetType of Object.keys(this.gameAssets)) {
      if (assetType != "sounds") {
        for (let each of this.gameAssets[assetType]) {
          assets[each.val] = this.isDefaultPreview ? each.defPath : each.path;
        }
      }
    }
    this.gameAssets = JSON.parse(JSON.stringify(assets));
  }

  ngAfterViewInit() {
    let comp = {
      'inputKey': 'launchGameMode', 'inputData': {
        'launchMode': this.mode,
        'launchType': this.wabType,
        'launchData': {
          'imagesData': this.gameAssets,
        },
        "whack_a_bingo_config": {
          "data": {
            "intro": [
              {
                "brand_id": this.selectedLabel,
                "custom_assets": false,
                "color_code": this.txtColor,
                "fonts_data": this.fontObj.font_info ?? {},
                "font_type": this.fontObj.font_type ?? '',
                "welcome_title": "Welcome to Whack A Bingo Chat"
              }
            ],
            "on_points": this.on_points_info,
          }
        },
        "wabchatConfig": {
          "game_config": {
            "data": {
              "intro": [
                {
                  "brand_id": this.selectedLabel,
                  "custom_assets": false,
                  "color_code": this.txtColor,
                  "fonts_data": this.fontObj.font_info ?? {},
                  "font_type": this.fontObj.font_type ?? '',
                  "welcome_title": "Welcome to Whack A Bingo Chat"
                }
              ],
              "display_name": "WAB_RFT1_copy22",
              "on_points": null,
              "pop_up_delay": 3,
              "hit_points": 100,
              "play_time": 60,
              "stay_up_time": 2,
              "event_id": "1573_FQGVCCZ_1721869200_2"
            },
            "feature_type": "whack_a_bingo_chat",
            "frameId": "1573_whack_a_bingo_chat"
          },
          "initial_config": {
            "launchType": "chat",
            "language": "en_US",
            "pLang": "en_US",
            "pcurrency": "USD",
            "exchange_rate": 1,
            "sessionKey": "en_US",
            "token": "",
            "envType": "qa2",
            "brandId": "foxybingo",
            "accountId": 4929701,
            "dynaconBrandId": "foxybingo.com",
            "isChUser": false,
            "chatGameData": {
              "leader_board_info": [
                {
                  "awards": {
                    "award_type": "bonus",
                    "bonus_type": "Bingo bonus",
                    "coupon": "NBFBC",
                    "prize_value": 10
                  },
                  "rank_range": [
                    1,
                    2
                  ],
                  "slab_no": 1
                }
              ],
              "schedule_config_id": 4055,
              "schedule_id": "1573_FQGVCCZ_1721869200",
              "chat_id": "1573",
              "event_type": "Single",
              "schedule_end_time": "2024-07-25 23:00:00"
            },

          },

          "frameId": "whackABingoFrame",
          "type": "chat_wab_initial_config"
        },
        'whack_a_bingo_initial_config': {
          'brandId': this.selectedLabel
        }
      }
    }
    if (!this.on_points_info) {
      let cashback_matrix = {
        "no_win": [
          1,
          50
        ],
        "points_slab": [
          [
            50,
            300
          ],
          [
            301,
            500
          ]
        ],
        "table_values": [
          [
            1,
            2
          ],
          [
            2,
            4
          ],
        ],
        "tickets_slab": [
          [
            1,
            10
          ],
          [
            11,
            30
          ],
        ]
      }
      Object.assign(comp.inputData.whack_a_bingo_config.data, { "cashback_matrix": cashback_matrix });
    }
    this.loadFeatureDailogsModule(comp);
  }

  private loadFeatureDailogsModule(reqComp: any) {
    import("../whack-a-bingo-client/whackabingo/wab.module").then(({ WhackBingoModule }) => {
      this.compiler.compileModuleAsync(WhackBingoModule).then(moduleFactory => {
        // Create a moduleRef, resolve an entry component, create the component
        let feature_moduleRef = moduleFactory.create(this.injector);
        let featurecompFactory = feature_moduleRef.instance['resolveComponent']();
        const { instance } = this.featurePrevieContainer.createComponent(featurecompFactory, { ngModuleRef: feature_moduleRef });
        if (reqComp.inputKey != null) {
          instance[reqComp.inputKey] = reqComp.inputData;
        }
        instance['soundEvent'].subscribe((soundName) => {
          this.playSounds.emit(soundName)
        });
        instance['onSaveconfig'].subscribe((colors) => {
          this.onSaveconfig.emit(colors)
        });
      });
    });
  }




  getImg(name: string): string {
    return this.gameAssets[name];
  }

  playWabSounds(soundName) {
    this.playSounds.emit(soundName);
  }

  gameEnd() {
    this.confirmAssets.emit(false);
  }

  updatesHits() {
    this.wabConfig.gameData.score += this.wabConfig.gameData.hitPoints;
  }

  onClose() {
    console.log("on Game close icon");
  }

  public Onconfirmation(response) {
    let isAccepted: boolean = false;
    switch (response) {
      case 'accept':
        isAccepted = true;
        break;
      case 'decline':
        isAccepted = false;
        break;
      case 'dismiss':
        isAccepted = false;
        break;
    }
    this.confirmAssets.emit(isAccepted);
  }

}